import Swiper from 'swiper';

export function setupIndustriesSlider(root: HTMLElement) {
  const sliderQuery = window.matchMedia('(max-width: 1199.98px)');
  const sliderElement = root.querySelector<HTMLElement>('.industries-swiper');
  let slider: Swiper | null = null;

  if (!sliderElement) return () => {};

  const syncSlider = () => {
    if (sliderQuery.matches && !slider) {
      slider = new Swiper(sliderElement, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          576: { spaceBetween: 20 },
        },
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        lazyPreloadPrevNext: 2,
        threshold: 5,
        resistanceRatio: 0.7,
      });
      return;
    }

    if (!sliderQuery.matches && slider) {
      slider.destroy(true, true);
      slider = null;
    }
  };

  syncSlider();
  sliderQuery.addEventListener('change', syncSlider);

  return () => {
    sliderQuery.removeEventListener('change', syncSlider);
    slider?.destroy(true, true);
  };
}
